export const GetNewTaskMilestone = Name => {
  return {
    Name,
  };
}